var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudArrowUpStroke = function SvgIconCloudArrowUpStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m31.54 31.544-1.599 1.603-3.445-3.438a.8.8 0 0 0-1.364.566v9.726h-2.266v-9.732c0-.712-.862-1.069-1.366-.565l-3.44 3.44-1.602-1.6L24.001 24zm-7.541-22.21c4.608 0 8.48 3.125 9.639 7.367a24.3 24.3 0 0 1 5.027 3v4.633a5 5 0 0 1-5 5h-1.129l-2.266-2.267h4.795c.737 0 1.333-.597 1.333-1.334v-4.888a21.7 21.7 0 0 0-4.737-2.504c-.49-3.796-3.736-6.74-7.662-6.74-4.264 0-7.733 3.469-7.733 7.733q0 .077.007.152l.005.115h-.946a3.74 3.74 0 0 0-3.733 3.733 3.74 3.74 0 0 0 3.733 3.733h2.398l-2.268 2.267h-.13a5.997 5.997 0 0 1-1.151-11.884c.882-4.62 4.94-8.116 9.818-8.116",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloudArrowUpStroke;